export const itTranslation = {
  "hotel_info": "Informazioni sull'albergo",
  "hotel": {
    "remove_preffered": "Rimuovi dai preferiti",
    "hotel": "Albergo",
    "s": "Alberghi",
    "found_from": "Alberghi trovati ",
    "full_cancellation_fee": "Cancellazione completa",
    "free_cancel_before": "Cancellazione gratuita prima di",
    "show_rooms": "Mostra stanze",
    "show_all_rooms": "Mostra tutte le stanze",
    "boarding": "La Base Ospitante",
    "refund_limit": "Cancellazione gratuita",
    "refund_price": "Prezzo del rimborso",
    "nights": "notti",
    "rooms": "Camere",
    "room": "La camera",
    "room_details": "Dettagli della camera",
    "nights_up": "Notti",
    "select_room": "Seleziona la sua camera",
    "filter": "Filtro...",
    "location": "Posizione dell'albergo",
    "book": "Pagare",
    "overview": "Informazioni generali",
    "facilities": "Servizi dell'albergo",
    "details": "Dettagli dell'albergo",
    "dates": "Date",
    "name": "Nome dell'albergo",
    "non_refundable": "Non rimborsabile",
    "rooms_prices": "Camere e prezzi ({{count}})",
    "desc": "Descrizione dell'hotel",
    "fac": "Servizi",
    "gallery": "Galleria",
    "choose_rooms": "Scegliere le camere",
    "single_room": "1 Camera - {{price}}",
    "multi_rooms": "{{count}} Camere - {{price}}",
    "rooms_price": "Camere e prezzi",
    "paxes": "Composizione della camera",
    "room_type": "Tipo di camera",
    "room_types": "Camera AI",
    "more_room_types": "{{count}} altri tipi di camera",
    "description": "Descrizione",
    "address": "Indirizzo",
    "loc": "Posizione",
    "hotel_facilities": "Servizi dell'albergo",
    "room_facilities": "Servizi in camera",
    "please_note": "Si prega di notare!",
    "you_can_choose": "È possibile scegliere fino a {{count}} pax",
    "we_suggestion": "Abbiamo trovato altri suggerimenti per voi",
    "max_rooms": "Si prega di scegliere non più di {{count}} camere",
    "max_paxes": "Si prega di scegliere non più di {{count}} pax",
    "specific_out": "La camera specifica è esaurita, ecco le alternative",
    "select_rooms": "Seleziona le camere",
    "info": "Info sull'albergo",
    "checking_room_availability": "Verifica la disponibilità della camera...",
    "one_hotel_search_failed": "La camera scelta non è disponibile, si prega di scegliere un'altra camera",
    "price_per_night": "Prezzo per notte",
    "grp": "Gruppo",
    "brd": "Imbarco",
    "bdr": "Camera da letto",
    "typ": "Tipo",
    "vew": "Vista",
    "bed": "Letto",
    "ada": "Accessibilità",
    "pax": "Composizione della camera",
    "cat": "Categoria",
    "blc": "Balcone",
    "cap": "Capacità",
    "sgl": "Uso singolo",
    "shr": "Condiviso",
    "filter_room_type": "Filtro per camera AI",
    "open_fitler": "Apre",
    "show_room_types": "Mostra i tipi di camera",
    "hide_room_types": "Nascondi i tipi di camera",
    "pay_credit_card": "Paga con carta di credito",
    "paid_successfully": "Pagato con successo",
    "group_rooms": "Raggruppa le camere",
    "ungroup_rooms": "Disaggregare le camere",
    "make_the_rooms_white": "Rendere le camere bianche",
    "make_the_rooms_colored": "Rendere le camere colorate",
    "supplier": "Fornitore",
    "order_summary": "Riepilogo dell'ordine",
    "with_meal": "Con pasto",
    "meal": "Pasto",
    "display_settings": "Opzioni di visualizzazione",
    "room_display": "Visualizzazione della camera",
    "clear_room_name": "Cancella il nome della camera",
    "filter_rooms": "Filtrare le camere simili",
    "our_lowest_prices": "I nostri prezzi più bassi",
    "show_cube_design": "Mostra cubo design",
    "show_rooms_in_tab": "Mostra le camere in una scheda",
    "show_cube_design_by_eat": "Mostra il design del cubo per imbarco",
    "is_short_mode": "Modalità fila",
    "company_id": "Azienda #:",
    "rem_condition": "Osservazioni condizione",
    "remarks": "Osservazioni",
    "backoffice_trip": "BackOffice/Trip#: (0 = nuovo viaggio)",
    "cancellation_policy": "Politica di cancellazione",
    "sales_price": "Prezzo di vendita",
    "percent": "Percentuale",
    "amount": "Importo",
    "professional": "Professionale",
    "client": "Cliente",
    "professional_single": "Agente - Riga singola",
    "professional_single_multi": "Agente - Riga singola (Multi Prezzo)",
    "professional_single_2": "Agente - Riga singola per camera",
    "loca": "Posizione",
    "professional_v1": "Professionista V1",
    "professional_v2": "Professionista V2",
    "professional_v3": "Agente - Base/Categoria",
    "business_new": "Business - Base/Categoria",
    "price_new": "Business - Categoria/Tipo",
    "professional_v3_multi": "Agente - Base/Categoria (Multi Prezzo)",
    "business_new_multi": "Business - Base/Categoria (Multi Prezzo)",
    "price_new_multi": "Business - Categoria/Tipo (Multi Prezzo)",
    "professional_v4": "Agente - Categoria/Tipo",
    "professional_v4_multi": "Agente - Categoria/Tipo (Multi Prezzo)",
    "bussiness": "Bussiness",
    "display_mode": "Modalità display",
    "room_mode": "Modalità camera",
    "internal": "Interno",
    "tab": "Scheda",
    "config_saved": "Configurazione salvata",
    "room_changed_after_one_hotel_search": "Camera cambiata dopo la ricerca di un hotel",
    "get_serialiezed_config": "Ottenere la configurazione serializzata",
    "serialized_config_clipboard": "Config serializzato copiato negli appunti",
    "center_me": "Centrami",
    "focus": "Mettere a fuoco",
    "pin_this_item": "Appunta questo elemento",
    "room_status": "Stato della camera",
    "about_room": "Informazioni sulla camera",
    "room_info": "Info sulla camera",
    "preffered": "Preferita",
    "excluded": "Escluso",
    "preferred_saved": "Configurazione hotel preferita salvata",
    "language": "Lingua",
    "positive_reviews": "Recensioni positive",
    "negative_reviews": "Recensioni negative",
    "price_breakdown": "Ripartizione del prezzo",
    "non_ref": "Non rimborsabile",
    "rooms_were_not_found": "Le camere non sono state trovate",
    "add_special_request": "Aggiungi una richiesta speciale",
    "please_add_special_request": "Si prega di aggiungere una richiesta speciale",
    "sorry_we_cant_find_hotel_here": "Siamo spiacenti, non riusciamo a trovare l'hotel qui",
    "we_are_checking_for_better_rates": "Stiamo verificando se ci sono tariffe migliori",
    "we_are_waiting_for_the_chosen_room": "Siamo in attesa della camera scelta",
    "original_room_description": "Descrizione originale della camera",
    "hotel_reservation_in_process": "Prenotazione alberghiera in corso",
    "number_of_persons": "Numero di persone",
    "search_room": "Ricerca camera",
    "google": "Google",
    "tripadvisor": "Tripadvisor",
    "monitor": "Monitoraggio",
    "copy": "Copia",
    "proposal": "Proposta",
    "find_nearly": "Trova vicino",
    "preferred_hotel": "Albergo preferito",
    "system_recommended": "Consigliato dal Sistema",
    "travel_agent_recommended": "Raccomandato dall'Agente di viaggio ",
    "client_recommended": "Raccomandato dal cliente",
    "stars": "Stelle",
    "search": "Ricerca in corso",
    "prices": "Prezzi",
    "rated_by_reviews": "Valutato da {{rating}} recensioni",
    "reservation_is_refundable": "La prenotazione è rimborsabile secondo le regole di tariffa/tariffa.",
    "reservation_is_not_refundable": "La prenotazione non è rimborsabile secondo le regole di tariffa/tariffa.",
    "choose_up_to_5_cards": "Scegli fino a 5 carte",
    "multi_payment": "Multi pagamenti",
    "please_apply_every_price": "Applica ogni prezzo",
    "please_enter_valid_price": "Inserisci un prezzo valido",
    "view_1": "Vista 1",
    "view_2": "Vista 2",
    "display_style": "Stile di visualizzazione",
    "positive_reviews_tags": "Etiquette di recensioni positive",
    "negative_reviews_tags": "Etiquette di recensioni negative",
    "ai_notes": "Note AI",
    "hotel_type": "Tipo di hotel",
    "apartment": "Appartamento",
    "villa": "Villa",
    "view_on_website": "Sito web dell'hotel"
  },
  "proposal": {
    "s": "Proposte",
    "remove_proposal": "Rimuovi proposta",
    "max_images_selected": "Hai selezionato il numero massimo di immagini",
    "proposal_removed": "Proposta rimossa",
    "display_order": "Ordine di visualizzazione",
    "proposal": "Proposta",
    "no": "Nessuna proposta",
    "download_pdf": "Scarica il PDF",
    "send_email": "Invia un'e-mail",
    "create": "Crea proposta",
    "clear_all": "Cancella tutto",
    "write_comments": "Scrivi qui i tuoi commenti...",
    "reviews": "Recensioni",
    "created": "La proposta è stata creata",
    "show_price": "Mostra il prezzo",
    "please_select_rooms": "Si prega di selezionare le camere",
    "update": "Update",
    "update_all": "Update all",
    "fixed_value": "Fixed value",
    "percentage": "Percentage",
    "edit_price": "Modifica prezzo",
    "value": "Valore",
    "add_to": "Aggiungi alla proposta",
    "details": "Dettagli",
    "amenities": "Servizi",
    "all_of_images": "Tutte le immagini",
    "dep": "Dep.",
    "dep_airport": "Dep. Aeroporto",
    "arr": "Arr.",
    "arr_airport": "Arr. Aeroporto",
    "dynamic": "Dinamico",
    "generated_by_user": "Generato dall'utente",
    "created_at": "Creato il",
    "flight_and_hotel": "Volo e hotel",
    "google_images": "Informazioni importanti: le immagini degli hotel di Google",
    "customize": "Personalizza",
    "simple_template": "Template semplice",
    "colorful_template": "Template colorato",
    "contrast_template": "Template contrastato",
    "room_price_option": "Opzione di prezzo della camera",
    "description": "Descrizione",
    "edit": "Modifica proposta",
    "some_of_the_products_were_expired": "Alcuni dei prodotti sono scaduti",
    "by_order_id": "Per ordine #",
    "by_service_date": "Per data di servizio",
    "original": "Originale",
    "overwrite_price": "Sovrascrivere il prezzo",
    "discount_hotel_limit": "Sconto hotel limit {{minPrice}}",
    "save": "Salva proposta",
    "whatsapp_message": "Per favore, trova il documento della proposta di viaggio allegato. ",
    "telegram_message": "Per favore, trova il documento della proposta di viaggio allegato.",
    "show_cancellation_date": "Mostra data di cancellazione",
    "cancellation_date_delta": "Data di cancellazione meno giorni",
    "ai_hotel_info": "Informazioni hotel AI",
    "item_view": "Vista elemento",
    "trip_view": "Vista viaggio"
  },
  "map": {
    "list": "Lista",
    "map": "Mappa",
    "show": "Mostra la mappa"
  },
  "bed_filter": {
    "title": "Filtro per camera",
    "pin_only": "Solo fissati"
  },
  "assistant": {
    "tab_tooltip": "Assistente IA",
    "greeting": "Chiedi informazioni su hotel o voli, ad esempio: \"voli per Parigi la prossima settimana\" o \"hotel 5 stelle con colazione\".",
    "placeholder": "Chiedi informazioni su hotel o voli…",
    "connecting": "Connessione…",
    "send": "Invia",
    "connection_error": "Impossibile connettersi all'assistente. Riprova.",
    "send_error": "Impossibile inviare il messaggio. Riprova.",
    "loading": "Caricamento…",
    "session": "Sessione",
    "copy_session_id": "Copia l'ID della sessione",
    "copied": "Copiato",
    "model": "Modello IA",
    "session_viewer": "Visualizzatore sessioni",
    "results_opened": "I risultati sono nella pagina",
    "search_failed": "Impossibile aprire la ricerca nella pagina. Riprova.",
    "widget_title": "Assistente IA",
    "widget_open": "Apri l'assistente IA",
    "widget_close": "Riduci a icona l'assistente IA",
    "widget_new_reply": "Nuova risposta dell'assistente IA",
    "voice": {
      "record": "Registra un messaggio vocale",
      "stop": "Invia il messaggio vocale",
      "cancel": "Annulla la registrazione",
      "recording": "Registrazione…",
      "mic_denied": "Il microfono è bloccato. Consentilo per questo sito nel browser e riprova.",
      "unsupported": "I messaggi vocali non sono supportati da questo browser.",
      "not_understood": "Non sono riuscito a capire il messaggio. Riprova.",
      "error": "Impossibile elaborare il messaggio vocale. Riprova.",
      "limit": "Troppi messaggi vocali. Riprova più tardi."
    },
    "feedback": {
      "open": "Valuta questa risposta",
      "sent": "Il tuo feedback è stato inviato. Clicca per modificarlo",
      "title": "Il tuo feedback",
      "q_understood": "Ha capito la richiesta?",
      "q_correct": "Informazioni corrette?",
      "q_helped": "Ti ha aiutato ad andare avanti?",
      "yes": "Sì",
      "no": "No",
      "placeholder": "Altro da aggiungere? (facoltativo)",
      "send": "Invia",
      "sending": "Invio…",
      "thanks": "Grazie per il tuo feedback!",
      "error": "Impossibile inviare il feedback. Riprova.",
      "close": "Chiudi",
    },
    "viewer": {
      "title": "Assistente IA · Visualizzatore sessioni",
      "close": "Chiudi",
      "company": "Società",
      "department": "Reparto",
      "branch": "Filiale",
      "user": "Utente",
      "status": "Stato",
      "from": "Dal",
      "to": "Al",
      "search": "Cerca",
      "search_placeholder": "ID sessione o parole della chat",
      "all_companies": "Tutte le società",
      "all_departments": "Tutti i reparti",
      "all_branches": "Tutte le filiali",
      "all_users": "Tutti gli utenti",
      "all_statuses": "Tutti gli stati",
      "reset": "Reimposta",
      "refresh": "Aggiorna",
      "col_started": "Inizio",
      "col_last": "Ultima attività",
      "col_user": "Utente",
      "col_company": "Società",
      "col_department": "Reparto",
      "col_branch": "Filiale",
      "col_messages": "Messaggi",
      "col_status": "Stato",
      "col_first_message": "Primo messaggio",
      "empty": "Nessuna sessione corrisponde a questi filtri.",
      "error": "Impossibile caricare le sessioni. Riprova.",
      "forbidden": "Solo il personale BePro può aprire il visualizzatore sessioni.",
      "rows_per_page": "Righe per pagina",
      "range": "{{from}}–{{to}} di {{total}}",
      "prev": "Pagina precedente",
      "next": "Pagina successiva",
      "details": "Sessione",
      "locale": "Lingua",
      "search_id": "ID ricerca",
      "tokens": "Token",
      "tokens_short": "token",
      "feedback_filter": "Feedback",
      "col_feedback": "Feedback",
      "col_tokens": "Token inviati / ricevuti",
      "tokens_in_out_hint": "Token inviati al modello / ricevuti da esso",
      "feedback_open": "Mostra i feedback",
      "feedback_title": "Feedback",
      "feedback_open_session": "Apri la sessione",
      "feedback_empty": "Nessun feedback in questa sessione.",
      "feedback_like": "Piaciuta",
      "feedback_dislike": "Non piaciuta",
      "feedback_comment": "Solo commento",
      "feedback_comment_label": "Commento",
      "feedback_no_text": "Nessun commento",
      "feedback_q_understood": "Richiesta compresa",
      "feedback_q_correct": "Informazioni corrette",
      "feedback_q_helped": "Ha aiutato a procedere",
      "feedback_yes": "Sì",
      "feedback_no": "No",
      "feedback_unanswered": "—",
      "feedback_question": "Domanda dell'utente",
      "feedback_answer": "Risposta dell'assistente",
      "feedback_copy": "Copia per lo sviluppatore",
      "feedback_copy_header": "Feedback sull'Assistente IA",
      "feedback_rating": "Valutazione",
      "feedback_date": "Data",
      "conversation": "Conversazione",
      "tool_calls": "Chiamate agli strumenti",
      "show_tools": "Mostra le chiamate agli strumenti",
      "blocked_by_guard": "Bloccato dal filtro",
      "failed_calls": "Chiamate non riuscite",
      "role_user": "Utente",
      "role_assistant": "Assistente",
      "role_system": "Sistema",
      "input": "Input",
      "error_detail": "Errore",
      "no_messages": "Questa sessione non ha ancora messaggi."
    }
  },
  "close": "Chiudere",
  "more": "Più",
  "less": "Meno",
  "actions": "Azioni",
  "all": "Tutti",
  "apply": "Applicare",
  "apply_2": "Applicare",
  "choose": "Scegliere",
  "from": "da",
  "to": "a",
  "type": "Tipo",
  "at": "a",
  "km": "km",
  "name": "Nome",
  "price": "Prezzo",
  "original_price": "Prezzo originale",
  "reset": "Azzeramento",
  "continue": "Continua",
  "total": "Totale",
  "basis": "Base",
  "taxes": "Tasse",
  "back": "Indietro",
  "days_sm": "g",
  "hours_sm": "h",
  "minutes_sm": "m",
  "confirm": "Confermare",
  "title": "Titolo",
  "male": "Uomo",
  "female": "Femmina",
  "child": "Bambino",
  "success": "Successo",
  "failed_order": "Ordine fallito. Prego di Chiamare l'assistenza",
  "error": "Errore",
  "notes": "Note",
  "note": "Nota",
  "show_less": "Mostra meno",
  "show_more": "Mostra di più",
  "show_all": "Mostra tutti",
  "no_entries": "Nessuna voce",
  "best": "Il migliore",
  "day": "Giorno",
  "ok": "OK",
  "of": "di",
  "add": "Aggiungi",
  "save": "Salva",
  "yes": "Sì",
  "delete": "Elimina",
  "order_created_successfully": "Ordine creato con successo",
  "session_expired_try_again": "Sessione scaduta. Riprovare",
  "cancel": "Annulla",
  "NOFSHON": "Minivacanza",
  "change_choice": "Cambia scelta",
  "click_here": "Fare clic qui",
  "details": "Dettagli",
  "clear": "Cancella",
  "clear_all": "Cancella tutto",
  "REG": "Regolare",
  "pay_wait": "Attendere prego...",
  "pay_wait_text": "L'ordine è in fase di elaborazione",
  "pay_processing": "Elaborazione del pagamento...",
  "normal": "Normale",
  "credit": "Credito",
  "only_english_input": "Si prega di inserire il nome e il cognome così come appare sul passaporto",
  "nights": "notti",
  "something_went_wrong": "Qualcosa è andato storto",
  "accessibility": "Accessibilità",
  "payment_error": "Il pagamento non è riuscito.",
  "MultipleDestinations": "Multi città",
  "RoundTrip": "Viaggio di andata e ritorno",
  "OneWay": "Solo andata",
  "eEconomyClass": "Economy",
  "eEconomyPlusClass": "Economy Plus",
  "eBusinessClass": "Business",
  "rules": "Regole",
  "click_for_details": "Clicca per i dettagli",
  "TRAVELFUSION": "LOW",
  "ro": "Solo camera",
  "bb": "Colazione inclusa",
  "fb": "Pensione completa",
  "ai": "Tutto incluso",
  "show_cancellation_date": "Mostra data di cancellazione",
  "cancellation_date_delta": "Delta giorni data di cancellazione",
  "add_to": "Aggiungi alla proposta",
  "max_images_selected": "È possibile selezionare un massimo di 3 immagini",
  "ai_hotel_info": "Info hotel IA",
  "claude": {
    "pets": "Animali domestici",
    "cancellation": "Cancellazione",
    "adults_only": "Solo adulti",
    "website": "Sito web",
    "notes": "Note",
    "pros": "Pro",
    "cons": "Contro",
    "pros_cons": "Pro e contro",
    "not_found": "Hotel non trovato"
  },
  "login": {
    "login": "Login",
    "login_your": "Accedi al tuo account",
    "username": "Nome utente",
    "password": "Password",
    "success": "Accesso effettuato con successo",
    "off_success": "Disconnesso con successo",
    "error": "Nome utente o password errati",
    "off": "Disconnettersi",
    "contact_us": "Contattateci",
    "get_back": "Contattateci",
    "select_number": "Selezionare il numero di passeggeri",
    "full_name": "Nome e cognome",
    "contact_us_success": "Il tuo messaggio è stato inviato con successo",
    "contact_us_error": "Si è verificato un errore durante l'invio del messaggio",
    "as": "Accesso come",
    "usercode": "Codice utente"
  },
  "validation": {
    "numbers": "Sono ammessi solo numeri",
    "email": "Email non corretta",
    "required": "Il campo è obbligatorio",
    "minLength": "Il campo deve contenere almeno {1} caratteri",
    "maxLength": "Il campo deve contenere {1} caratteri o meno",
    "length": "Il campo deve contenere {1} caratteri",
    "english": "Sono ammessi solo caratteri inglesi"
  },
  "mo": {
    "mo": "I miei ordini",
    "segment_gross_edited": "Segmento lordo modificato con successo",
    "lock_pnr": "Blocca PNR",
    "unlock_pnr": "Sblocca PNR",
    "lock_pnr_success": "PNR bloccato con successo",
    "unlock_pnr_success": "PNR sbloccato con successo",
    "logs": "Log",
    "open_log": "Apri log",
    "table_settings": "Impostazioni tabella",
    "support_ticket": "Ticket di supporto",
    "support_ticket_success": "Ticket di supporto creato con successo",
    "subject": "Oggetto",
    "reply": "Rispondi",
    "ticket": "Ticket",
    "ticket_updated": "Ticket aggiornato con successo",
    "segment_id": "Id del segmento",
    "order_id": "Id ordine",
    "order": "Ordine",
    "local": "Locale",
    "supplier_pnr": "PNR del fornitore",
    "backoffice_id": "Id Backoffice",
    "passenger_name": "Nome del passeggero",
    "creation_date": "Data di creazione",
    "orders": "Ordini",
    "segment": "Seg.",
    "segment_full": "Segmento",
    "docket": "Documento",
    "pnr": "PNR",
    "start": "Inizio",
    "name": "Nome",
    "dest": "Dest.",
    "items": "Voci",
    "clx": "CLX",
    "status": "S",
    "voucher": "V",
    "quantity": "Q",
    "total": "Totale",
    "pay": "P",
    "supplier": "S",
    "end": "C",
    "agent": "Agente",
    "branch": "Filiale",
    "order_details": "Dettagli dell'ordine",
    "check_in": "Arrivo",
    "check_out": "Partenza",
    "nights": "Notti",
    "date_c": "Data C",
    "segment_details": "Dettagli del segmento",
    "paxes": "P.",
    "legs": "T.",
    "class": "C.",
    "date_time": "Data e ora",
    "arrival": "Arrivo",
    "status_full": "Stato",
    "pnr_ref": "Rif. PNR",
    "supplier_full": "Fornitore",
    "emergency_phone": "Telefono di emergenza",
    "support_email": "Email di supporto",
    "emergency_email": "Email di emergenza",
    "amount": "Importo",
    "gross": "Lordo",
    "coupon_code": "Codice coupon",
    "total_gross": "Totale lordo",
    "total_net": "Totale netto",
    "disc_coupon": "Sconto coupon",
    "vat": "Iva",
    "total_due": "Totale dovuto",
    "client_id": "Codice cliente",
    "discount": "Sconto",
    "comission": "Commissione",
    "profit": "Profitto",
    "remarks": "Osservazioni",
    "remark": "Osservazione",
    "info": "Info",
    "remark_code": "Codice",
    "order_seg_remark_id": "ID Osservazione",
    "desc": "Messaggio",
    "user": "Utente",
    "dateC": "Data C",
    "depatment": "Dipartimento",
    "voucher_full": "Voucher",
    "print_voucher": "Stampa del buono",
    "voucher_number": "Numero del buono",
    "backoffice_voucher_identity_number": "Numero di identità del buono di backoffice",
    "status_the_same": "Lo stato è lo stesso",
    "status_changed": "Lo stato è stato cambiato in {{status}}",
    "current_status": "Stato attuale",
    "product_type": "Tipo di prodotto",
    "back_to_orders": "Torna agli ordini",
    "cancel_order": "Annullamento dell'ordine",
    "segments": "Segmenti",
    "booking_about_to_cancel": "Questa prenotazione sta per essere cancellata.",
    "are_you_sure": "Ne è sicuro?",
    "order_cancelled": "L'ordine è stato cancellato con successo. Lo stato è stato cambiato in {{status}}.",
    "hello": "Ciao",
    "user_code": "Codice utente",
    "department": "Dipartimento",
    "loading": "Caricamento...",
    "supp": "Fornitore",
    "pnr_to_docket": "PNR in Cartella",
    "docket_success": "Il documento è salvato con successo",
    "clipboard_success": "Dati copiati negli appunti",
    "no_data_found": "Nessun dato trovato",
    "room_preferences": "Preferenze camera",
    "guest_notes": "Note ospite",
    "additional_requirements": "Requisiti aggiuntivi",
    "please_double_bed": "Se possibile, si prega di confermare una camera con un <b>letto matrimoniale</b>",
    "please_twin_beds": "Se possibile, si prega di confermare una camera con <b>due letti singoli</b>",
    "please_high_floor": "Se possibile, si prega di confermare una camera a un <b>piano alto</b>",
    "please_low_floor": "Se possibile, si prega di confermare una camera a un <b>piano basso</b>",
    "please_non_smoking": "Se possibile, si prega di confermare una camera <b>per non fumatori</b>",
    "please_smoking": "Se possibile, si prega di confermare una camera <b>per fumatori</b>",
    "please_adjoining_room": "Se possibile, si prega di confermare una camera <b>comunicante</b>",
    "please_connecting_rooms": "Se possibile, si prega di confermare <b>camere comunicanti</b>",
    "please_quiet_room": "Se possibile, si prega di confermare una camera <b>silenziosa</b>",
    "please_bathtub": "Se possibile, si prega di confermare una camera con <b>vasca da bagno</b>",
    "please_accessible_room": "Se possibile, si prega di confermare una camera <b>accessibile</b> o <b>adatta ai disabili</b> con <b>doccia a pavimento</b> (il cliente utilizza una sedia a rotelle)",
    "note_late_arrival": "Si prega di notare che l'ospite arriverà <b>tardi (dopo le 19:00)</b>",
    "confirm_early_arrival": "Si prega di confermare l'<b>arrivo anticipato</b> alle ore circa: ______",
    "confirm_late_arrival": "Si prega di confermare l'<b>arrivo tardivo</b> alle ore circa: ______",
    "confirm_late_checkout": "Si prega di confermare il <b>check-out tardivo</b> alle ore circa: ______",
    "note_no_voucher": "Si prega di notare: <b>l'ospite arriverà senza voucher</b>",
    "note_honeymoon": "Si prega di notare: <b>i passeggeri sono in luna di miele</b>",
    "confirm_baby_cot": "Se possibile, si prega di confermare una <b>culla</b> per:<br>Nome completo del neonato: {{fullName}} Data di nascita: {{dob}}",
    "add_confirm_baby_cot": "Si prega di aggiungere un neonato alla camera, se possibile, e confermare una culla per lui: nome completo: {{fullName}} Data di nascita: {{dob}}",
    "if_child": "Questo è se il neonato è nell'ordine",
    "if_no_child": "Se il neonato non è nell'ordine",
    "please_enter_info_about_baby": "Si prega di inserire le informazioni sul neonato",
    "change_request": "Richiesta speciale",
    "change_request_success": "Richiesta speciale inviata con successo",
    "choose_requests_can_edit": "Scegliere una o più richieste dall'elenco. È possibile modificare il testo della richiesta qui.",
    "order_information": "Ordine - Informazioni",
    "order_public_price": "Ordine - Prezzo al pubblico",
    "order_send_order_email": "Ordine - Invia ordine via e-mail",
    "order_agent": "Ordine - Agente",
    "order_operator": "Ordine - Operatore",
    "print": "Stampa",
    "send": "Invio",
    "print_file_generated": "Il file è stato creato con successo.",
    "documents": "Documenti",
    "file_name": "Nome del file",
    "file_type": "Tipo di file",
    "tran_id": "ID di Transazione",
    "ptr_id": "Id del PTR",
    "reason": "Motivo",
    "token": "Gettone",
    "p": "P",
    "a": "A",
    "t": "T",
    "err_code": "Codice errore",
    "payments": "Pagamenti",
    "order_report": "Rapporto ordine",
    "order_report_sent_success": "Rapporto ordine inviato con successo",
    "send_to_me": "Invia email a me {{email}}",
    "thin_report": "Rapporto sottile",
    "email_success": "Email inviata con successo",
    "voucher_type": "Tipo di voucher",
    "regular_voucher": "Voucher regolare",
    "thin_voucher": "Voucher sottile",
    "display_order": "Ordine di visualizzazione",
    "issue_voucher": "Emetti voucher",
    "copied": "Testo salvato negli appunti",
    "link_copied": "Link copiato negli appunti",
    "send_support_message": "Invia messaggio di supporto",
    "send_support_message_success": "Messaggio di supporto inviato con successo",
    "add_comission": "Aggiungi commissione",
    "item": "Elemento",
    "search_again": "Cerca di nuovo",
    "download_success": "Download riuscito",
    "units": "Unità",
    "order_list_report": "Rapporto elenco ordini",
    "order_list_report_no_names": "Rapporto elenco ordini - Senza nomi",
    "order_list_report_by_param": "Rapporto elenco ordini per parametro",
    "order_list_report_by_dest": "Rapporto elenco ordini per destinazione",
    "summary_report_by_department": "Rapporto riepilogativo per dipartimento",
    "summary_report_by_branch": "Rapporto riepilogativo per filiale",
    "summary_report_by_supplier": "Rapporto riepilogativo per fornitore",
    "orders_by_branch": "Ordini per filiale",
    "orders_by_currency": "Ordini per valuta",
    "orders_by_supplier": "Ordini per fornitore",
    "export_to_file": "Esporta in file",
    "export_to_file_no_names": "Esporta in file - Senza nomi",
    "export_to_file_refund": "Esporta in file - Rimborso",
    "refund_report": "Rapporto rimborsi",
    "coupon_report": "Rapporto coupon",
    "report_price": "Prezzo rapporto",
    "public_price": "Prezzo al pubblico",
    "sys_total_agent": "Totale sistema - Agente",
    "sys_nett_operator": "Netto sistema - Operatore",
    "report_type": "Tipo di rapporto",
    "report": "Rapporto",
    "report_generated": "Rapporto generato con successo",
    "currency": "Valuta",
    "tour_subject": "Oggetto del tour",
    "add_remark": "Aggiungi osservazione",
    "remark_added": "Osservazione aggiunta con successo",
    "ticket_number": "Numero di biglietto",
    "public": "Pubblico",
    "private": "Privato",
    "body": "Corpo",
    "support_update": "Aggiornamento ticket",
    "support_update_success": "Ticket aggiornato con successo",
    "itinerary": "Itinerario",
    "include": "Incluso",
    "not_included": "Non incluso",
    "information": "Informazioni",
    "start_price": "Da",
    "change_user": "Cambia utente",
    "change_user_success": "Utente cambiato con successo",
    "current_user": "Utente attuale",
    "data_saved": "Data salvata con successo",
    "agency": "Agenzia",
    "currencies": "Valute",
    "upload_logo": "Carica logo",
    "current_logo": "Logo attuale",
    "new_logo": "Logo nuovo",
    "last_update": "Ultimo aggiornamento",
    "download": "Scarica",
    "documents_uploaded_successfully": "{{count}} documenti caricati con successo",
    "no_files_selected": "Nessun file selezionato",
    "choose_files": "Seleziona file",
    "delete_document": "Elimina documento",
    "document_deleted": "Documento eliminato con successo",
    "all_departments": "Tutti i dipartimenti",
    "all_branches": "Tutte le filiali",
    "profile": "Profilo",
    "set_different_user": "Imposta utente diverso",
    "login_as": "Accedi come",
    "username": "Nome utente",
    "reset": "Ripristina",
    "logged_as_user_successfully": "Accesso effettuato con successo",
    "logged_as_user_reset_successfully": "Disconnesso con successo",
    "add_payment": "Aggiungi pagamento"
  },
  "destination": {
    "s_our_top": "Le nostre destinazioni consigliate"
  },
  "search": {
    "new": "Nuova ricerca",
    "remember_mode_enabled": "Modalità di ricordo attiva",
    "open_details_in_new_tab": "Apri dettagli in una nuova scheda",
    "your_latest_searches": "Le tue ultime ricerche",
    "radius": "Raggio",
    "no_results": "Nessun risultato trovato",
    "destination": "Destinazione",
    "check_in": "Arrivo",
    "check_out": "Partenza",
    "max_occupancy": "Occupazione massima",
    "rooms": "Camere",
    "room": "Camera",
    "star_rating": "Stelle",
    "nationality": "Nazionalità",
    "adults": "Adulti",
    "children": "Bambini",
    "youths": "Giovani",
    "seniors": "Anziani",
    "infants": "Neonati",
    "adult": "Adulto",
    "child": "Bambino",
    "youth": "Giovane",
    "senior": "Anziano",
    "infant": "Neonato",
    "under": "sotto",
    "add_room": "Aggiungi camera",
    "search": "Cerca",
    "max_persons": "Max persone: {{count}}",
    "infants_warning": "Il numero di neonati deve essere inferiore a quello degli adulti",
    "history": "Storico ricerche",
    "age": "Età del bambino (2-16)",
    "suppliers": "Fornitori",
    "with_active_filters": "Mantieni filtri",
    "display_exactly": "Mostra esattamente",
    "search_type_id": "ID tipo di ricerca"
  },
  "sort": {
    "er": "Ordinatore",
    "by": "Ordina per",
    "price_increase": "Prezzo: basso ad alto",
    "price_decrease": "Prezzo: alto a basso",
    "cxl_increase": "CXL: basso ad alto",
    "cxl_decrease": "CXL: alto a basso",
    "airline_increase": "Compagnia aerea: (A - Z)",
    "airline_decrease": "Compagnia aerea: (Z - A)",
    "star_increase": "Stelle: basse ad alte",
    "star_decrease": "Stelle: alte a basse",
    "hotel_increase": "Nome: (A - Z)",
    "hotel_decrease": "Nome: (Z - A)",
    "duration_increase": "Durata: bassa ad alta",
    "duration_decrease": "Durata: alta a bassa",
    "departure_outbound_increase": "Partenza più presto ({{dep}})",
    "departure_outbound_decrease": "Partenza più tardi ({{dep}})",
    "returning_outbound_increase": "Atterraggio più presto ({{arr}})",
    "returning_outbound_decrease": "Atterraggio più tardi ({{arr}})",
    "departure_inbound_increase": "Partenza più presto ({{arr}})",
    "departure_inbound_decrease": "Partenza più tardi ({{arr}})",
    "returning_inbound_increase": "Atterraggio più presto ({{dep}})",
    "returning_inbound_decrease": "Atterraggio più tardi ({{dep}})",
    "recommended": "Consigliato",
    "distance": "Distanza",
    "distance_increase": "Distanza: (0 - 100)",
    "distance_decrease": "Distanza: (100 - 0)",
    "name": "Nome",
    "star": "Stella"
  },
  "group": {
    "gr": "Gruppo",
    "special": "Speciale",
    "group": "Richiesta Speciale",
    "request": "Richiesta speciale",
    "request_type": "Tipo di richiesta",
    "hotel": "Hotel",
    "flight": "Volo",
    "destination": "Destinazione",
    "hotel_name": "Nome hotel",
    "room_type": "Tipo di camera",
    "double": "Matrimoniale",
    "single": "Singola",
    "triple": "Tripla",
    "quadro": "Quadrupla",
    "group_type": "Tipo della Richiesta",
    "hotel_stars": "Stelle",
    "stars_5": "5 stelle",
    "stars_4": "4 stelle",
    "stars_3": "3 stelle",
    "stars_2": "2 stelle",
    "star_1": "1 stella",
    "number_of_rooms": "Numero di camere",
    "check_in": "Arrivo",
    "check_out": "Partenza",
    "contact_information": "Informazioni di contatto",
    "agency_name": "Nome agenzia",
    "agent_fn": "Nome agente",
    "agent_ln": "Cognome agente",
    "agent_email": "Email agente",
    "agent_phone": "Telefono agente",
    "message": "Messaggio",
    "send_request": "Invia richiesta",
    "request_sent": "Richiesta inviata con successo",
    "from": "Da",
    "to": "A",
    "date": "Data",
    "flight_time": "Orario volo",
    "airline": "Compagnia aerea",
    "number_of_passengers": "Numero di passeggeri"
  },
  "filter": {
    "filter": "Filtri",
    "free_text": "Testo libero",
    "s": "Filtri",
    "stops": "Scali",
    "stop": "scalo",
    "stop_up": "Scalo",
    "stops_sm": "scali",
    "direct_flight": "Volo diretto",
    "direct_flights": "Voli diretti",
    "direct_flights_outbound": "Voli diretti outbound",
    "one_stop": "1 scalo",
    "two_or_more_stops": "2+ scali",
    "reset": "Ripristina filtri",
    "price_range": "Fascia di prezzo",
    "times": "Volte",
    "takeoff": "Decollo",
    "landing": "Atterraggio",
    "duration": "Durata",
    "stop_duration": "Durata dello scalo",
    "airlines": "Compagnie aeree",
    "airports": "Aeroporti",
    "by_name": "Nome",
    "by_rooms": "Camere",
    "by_stars": "Stelle",
    "by_prices": "Pezzi",
    "search_by_location": "Cerca per posizione",
    "more": "Altri filtri...",
    "free_cancellation": "Cancellazione gratuita",
    "board": "Pensione",
    "clear": "Cancella filtri",
    "baggage": "Bagaglio",
    "baggage_included": "Bagaglio incluso",
    "baggage_not_included": "Bagaglio non incluso",
    "meal": "Pasto",
    "airline": "Compagnia aerea",
    "free_x": "Gratuito",
    "is_less_than": "È inferiore a",
    "is_greater_than": "È maggiore di",
    "free": "Gratuito X",
    "preffered_hotels": "Hotel preferiti",
    "breakfast": "Colazione",
    "half_board": "Mezza pensione",
    "full_board": "Pensione completa",
    "all_inclusive": "Tutto incluso",
    "max_price": "Max prezzo",
    "min_price": "Min prezzo",
    "max": "Max",
    "min": "Min"
  },
  "home": {
    "home": "Inizio",
    "session_expired": "Sessione scaduta",
    "session_expired_desc": "La sua sessione è scaduta. Prova a cercare di nuovo",
    "go_back": "Torna all'Inizo",
    "search_out_of_date": "I risultati della ricerca potrebbero essere obsoleti",
    "please_refresh": "Si prega di aggiornare i risultati della ricerca",
    "refresh_results": "Aggiorna risultati",
    "new_search": "Nuova ricerca",
    "confirmation_dialog": "Finestra di conferma",
    "password": "Password",
    "wrong_password": "Password errata",
    "failed_to_pay": "Impossibile creare l'ordine, l'ordine è stato annullato durante il processo di prenotazione. Riprova"
  },
  "passenger": {
    "as_client": "Come cliente",
    "as_agent": "Come agente",
    "details": "Dettagli passeggero",
    "important_notes": "Note importanti",
    "apartment_notes": "Si prega di notare: La reception non è disponibile in alcuni appartamenti. La check-in è online, e i codici di accesso sono inviati in anticipo.",
    "passenger": "Passeggero",
    "s": "Passeggeri",
    "guest": "Persona",
    "guests": "Persone",
    "gender": "Genere",
    "male": "Maschio",
    "female": "Femmina",
    "ln": "Cognome",
    "fn": "Nome",
    "dob": "Data di nascita",
    "phone": "Telefono",
    "email": "Email",
    "confirm": "Si prega di confermare che accetti i termini",
    "read_more": "Leggi di più",
    "attention": "Attenzione! La tua prenotazione è già in politica di penalità",
    "order_details": "Dettagli dell'ordine",
    "cancellation_details": "Dettagli della cancellazione",
    "cancellation_date": "È possibile annullare l'ordine entro",
    "cancellation_outdate": "Non può essere annullato. Tutte le commissioni di annullamento",
    "booking_summary": "Riepilogo della prenotazione",
    "room_count": "Conteggio camere",
    "confirm_order": "Conferma ordine",
    "room": "Camera",
    "optional_services": "Servizi opzionali (Bagagli e Pasti)",
    "methods_of_payment": "Metodi di pagamento",
    "fast_secure": "Pagamento veloce e sicuro con carta di credito",
    "transaction_type": "Tipo di transazione",
    "number_of_payments": "Numero di pagamenti",
    "send_request_to_consultant": "Invia una richiesta al consulente di viaggio",
    "green_button_tooltip": "Preferisci pagare a uno dei nostri rappresentanti? Premere il pulsante verde per prenotare il tuo posto e un rappresentante ti chiamerà presto.",
    "send_request": "Invia richiesta",
    "rule_display": "Regola Display",
    "rule_i": "Regola {{i}}. {{fareBase}} | {{airlineCode}} | {{departureCode}}-{{arrivalCode}}",
    "message": "Messaggio",
    "birthday": "Compleanno",
    "years": "anni",
    "confirm_order_text": "Conferma ordine di prenotazione",
    "mr": "Sig.",
    "mrs": "Sig.ra",
    "miss": "Sig.na",
    "ms": "Sig.",
    "dr": "Dott.",
    "prof": "Prof.",
    "title": "Titolo",
    "phone_country": "Paese telefono",
    "add": "Aggiungi passeggero",
    "passport_valid_till": "Passaporto valido fino al",
    "passport": "Passaporto",
    "price_for_single_in_composition_for_double": "Prezzo per singola in composizione per doppia",
    "order_id": "ID ordine",
    "id_number": "Numero documento",
    "cancel_order_success": "Inviato con successo",
    "city": "Città",
    "branch_title": "Titolo della filiale",
    "display_cancellation_policy": "Mostra la politica di cancellazione",
    "please_wait": "Si prega di attendere...",
    "your_payment_is_being_processed": "Il pagamento è in corso di elaborazione",
    "fast_secure_multi_payment": "Pagamento veloce e sicuro con un massimo di {{count}} carte di credito",
    "procces_with_revolut": "Processe con Revolut",
    "pay": "Paga",
    "every_hotel_has_room": "Ogni hotel deve avere una camera"
  },
  "access": {
    "accessibility_settings": "Impostazioni di accessibilità",
    "internet_accessibility": "L'accessibilità internet significa che le persone con disabilità possono usare internet",
    "contrast": "Contrasto",
    "dark": "Scuro",
    "normal": "Normale",
    "bright": "Luminoso",
    "color": "Colore",
    "high": "Alto",
    "black_white": "Bianco e nero",
    "font_size": "Dimensione carattere",
    "clear_selection": "Cancella selezione"
  },
  "deal": {
    "tours": "Tour",
    "fly_drive": "Fly Drive",
    "nofshon": "Pacchetto turistico",
    "ski": "Sci",
    "spa": "Spa",
    "sport": "Sport",
    "cruise": "Crociera"
  },
  "cookie": {
    "cookie_policy": "Cookie Policy",
    "title": "Valore la tua privacy.",
    "text": "Utilizziamo i cookie per migliorare la tua esperienza di navigazione, servire pubblicità o contenuto personalizzato e analizzare il nostro traffico. Cliccando su \"Accetta tutto\", acconsenti all'utilizzo dei nostri cookie.",
    "accept": "Accetta tutto",
    "reject": "Rifiuta tutto"
  }
};
